import { GetterTree } from "vuex";

import { AppEventState } from '@/models/AppEventState';
import { i18n } from '@/i18n';
import { LocalizableField } from '@/models/LocalizableField';

export const getters: GetterTree<AppEventState, {}> = {
    eventTitle(state: AppEventState): string {
        return state.title[i18n.locale as keyof LocalizableField];
    },
    eventCode(state: AppEventState): string {
        return state.code;
    },
    eventStartDate(state: AppEventState): string {
        return state.startDate;
    },
    eventEndDate(state: AppEventState): string {
        return state.endDate;
    },
    eventDomains(state: AppEventState): string[] {
        return state.domains;
    },
    eventId(state: AppEventState): number {
        return state.id;
    },
};
